import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  base_url = environment.base_url;

  constructor(
    private http: HttpClient
  ) { }

  login(dados: any): Promise<any> {
    return this.http.post(`${this.base_url}/auth/login`, dados).toPromise()
  }

  loginLeilao(dados: any): Promise<any> {
    return this.http.post(`${this.base_url}/leilao/login`, dados).toPromise()
  }

  getUserByToken(queryParams: any = {}): Promise<any> {
    return this.http.post(`${this.base_url}/auth/me`, { params: queryParams }).toPromise();
  }

  getUserByToken2(queryParams: any = {}): Promise<any> {
    return this.http
      .post(`${this.base_url}/auth/me`, { params: queryParams })
      .toPromise()
      .then(response => {
        console.log('Resposta /auth/me:', response);
        return response;
      })
      .catch(error => {
        console.error('Erro /auth/me:', error);
        throw error;
      });
  }
}
